import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface Wallet {
  id: string;
  owner_id: string;
  owner_type: string;
  currency_type_id: string;
  currency_code: string;
  currency_name: string;
  balance: number;
  is_active: number;
}

export interface InternalTransfer {
  id: string;
  from_wallet_id: string;
  to_wallet_id: string | null;
  amount: number;
  currency_type_id: string;
  currency_name?: string;
  currency_code?: string;
  status: 'pending' | 'completed' | 'cancelled' | 'expired' | 'reversed';
  qr_token: string;
  qr_expires_at: number;
  notes?: string;
  created_by: string;
  received_by?: string;
  received_at?: number;
  created_at: number;
  from_user_name?: string;
  to_user_name?: string;
}

export const internalTransferService = {
  async getMyWallets(): Promise<Wallet[]> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/internal-transfers/my-wallets`);
    return response.data || [];
  },

  async list(): Promise<InternalTransfer[]> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/internal-transfers`);
    return response.data || [];
  },

  async create(data: {
    from_wallet_id: string;
    currency_type_id: string;
    amount: number;
    notes?: string;
  }): Promise<InternalTransfer & { qr_url: string }> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/internal-transfers`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response.data;
  },

  async get(id: string): Promise<InternalTransfer> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/internal-transfers/${id}`);
    return response.data;
  },

  async cancel(id: string, reason?: string): Promise<void> {
    await authService.fetchWithAuth(`${API_URL}/api/internal-transfers/${id}/cancel`, {
      method: 'POST',
      body: JSON.stringify({ reason }),
    });
  },

  async receive(qrToken: string): Promise<any> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/internal-transfers/receive/${qrToken}`,
      { method: 'POST' }
    );
    return response.data;
  },
};